// extracted by mini-css-extract-plugin
export var container = "_4z-0";
export var infoButton = "_4z-1";
export var label = "_4z-3";
export var labelExpanded = "_4z-4";
export var price = "_4z-5";
export var priceExpanded = "_4z-6";
export var title = "_4z-2";